var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.results && _vm.results.length)?_c('div',_vm._l((_vm.results),function(b,index){return _c('div',{key:index,staticClass:"cetin-vysledek-card zmensit"},[_vm._v("\n\t\t"+_vm._s(b)+"\n\t")])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bf9b683","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search_provider/results/CetinBondingResult.vue
// module id = null
// module chunks = 